import script from "./CreateLead.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateLead.vue?vue&type=script&setup=true&lang=ts"

import "./CreateLead.vue?vue&type=style&index=0&id=6c229f03&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c229f03"]])

export default __exports__